export function calculateAspectRatio() {
    document.addEventListener("lazyloaded", function (e) {
        e.srcElement.parentNode.style.background = "none";
    });
}

export const getSizedImageUrl = (src, size) => {
    if (!src) {
        return;
    }
    const match = src.match(/\.(jpg\.webp|jpeg\.webp|jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match) {
        const prefix = src.split(match[0]);
        const suffix = match[0];
        src = prefix[0] + "_" + size + "x" + suffix;
    }
    return src;
};
